import { FormValues } from './utils/values';

export interface FormErrors {
  name?: string;
  queueId?: string;
  historyStartDateTime?: string;
  historyEndDateTime?: string;
  forecastStartDateTime?: string;
  forecastEndDateTime?: string;
}

export const validateCreateForecastForm = (values: FormValues) => {
  const errors: FormErrors = {};

  if (!values.name) {
    errors.name = 'Required';
  }

  if (!values.queueId) {
    errors.queueId = 'Required';
  }

  if (!values.historyRange?.startDateTime) {
    errors.historyStartDateTime = 'Required';
  }

  if (!values.historyRange?.endDateTime) {
    errors.historyEndDateTime = 'Required';
  }

  if (!values.forecastRange?.startDateTime) {
    errors.forecastStartDateTime = 'Required';
  }

  if (!values.forecastRange?.endDateTime) {
    errors.forecastEndDateTime = 'Required';
  }

  return errors;
};
